import mitt, { Emitter } from 'mitt';

type MittInstance = Emitter<{
  showSizeChart: {
    sku: string;
  };
  updateReviewCache: {
    reviewItemId: number;
    reviewHelpfulItemId: number;
    is_help: number;
    is_not_help: number;
    is_help_count: number;
    is_not_help_count: number;
  };
  updateReviewPhotoGalleryCache: {
    reviewItemId: number;
    reviewHelpfulItemId: number;
    is_help: number;
    is_not_help: number;
    is_help_count: number;
    is_not_help_count: number;
  };
  openServerNavigateLoading: void;
}>;
export const mittInstance: MittInstance = mitt();
